var render = function render(_c,_vm){return _c('transition',{attrs:{"name":"binds-snackbar","appear":""}},[_c('div',{staticClass:"binds-snackbar",class:_vm.props.bindsClasses},[_c('div',{staticClass:"binds-snackbar-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }